var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutOfStock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    fill: "#000",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "normal"
    },
    fill: "none",
    stroke: "none",
    strokeDashoffset: 0,
    strokeWidth: 1,
    fontFamily: "none",
    fontSize: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,172v-172h172v172z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#353535"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.76,10.23938c-1.89469,0 -3.44,1.54531 -3.44,3.44v141.20125c0,1.89469 1.54531,3.44 3.44,3.44h84.23969c-1.14219,-2.19031 -2.12312,-4.48813 -2.9025,-6.88h-77.89719v-134.32125h137.6v79.21406c2.41875,1.00781 4.70313,2.24406 6.88,3.64156v-86.29562c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM68.8,27.52c-5.65719,0 -10.32,4.66281 -10.32,10.32c0,0.91375 0.36281,1.78719 1.02125,2.43219c1.20938,4.35375 4.58219,7.88781 9.29875,7.88781h34.4c4.71656,0 8.08938,-3.53406 9.29875,-7.88781c0.65844,-0.645 1.02125,-1.51844 1.02125,-2.43219c0,-5.65719 -4.66281,-10.32 -10.32,-10.32zM68.8,34.4h34.4c1.94844,0 3.44,1.49156 3.44,3.44c0,1.94844 -1.49156,3.44 -3.44,3.44h-34.4c-1.94844,0 -3.44,-1.49156 -3.44,-3.44c0,-1.94844 1.49156,-3.44 3.44,-3.44zM137.6,103.2c-9.16437,0 -17.49562,3.62813 -23.66344,9.51375c-0.51063,0.29563 -0.94063,0.71219 -1.23625,1.23625c-5.87219,6.16781 -9.50031,14.48563 -9.50031,23.65c0,18.96031 15.43969,34.4 34.4,34.4c9.1375,0 17.44188,-3.61469 23.60969,-9.46c0.55094,-0.30906 1.02125,-0.76594 1.33031,-1.33031c5.84531,-6.16781 9.46,-14.47219 9.46,-23.60969c0,-18.96031 -15.43969,-34.4 -34.4,-34.4zM137.6,110.08c15.23813,0 27.52,12.28188 27.52,27.52c0,6.36938 -2.16344,12.21469 -5.79156,16.8775l-38.60594,-38.60594c4.66281,-3.62813 10.50813,-5.79156 16.8775,-5.79156zM115.87156,120.7225l38.60594,38.60594c-4.66281,3.62813 -10.50812,5.79156 -16.8775,5.79156c-15.23812,0 -27.52,-12.28187 -27.52,-27.52c0,-6.36937 2.16344,-12.21469 5.79156,-16.8775z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfStock);
export default __webpack_public_path__ + "static/media/out-of-stock.ff745a34fa78bdaa049205c6e1dcf82e.svg";
export { ForwardRef as ReactComponent };